import React from "react";

import {
  FaBriefcase,
  FaCamera,
  FaHamburger,
  FaCoffee,
  FaGlassMartini,
  FaBus,
} from "react-icons/fa";
import { BiDotsHorizontalRounded } from "react-icons/bi";
import { HiLocationMarker } from "react-icons/hi";
import {
  MdLocalDining,
  MdDirectionsWalk,
  MdGroups,
  MdTimer,
} from "react-icons/md";
import { encode, decode } from 'js-base64';

export const getIcon = (inclusionType) => {
  switch (inclusionType) {
    case "Equipment":
      return (
        <FaBriefcase
          style={{ marginLeft: "auto", fontSize: 22, color: "#A9A9A9" }}
        />
      );
    case "Pictures":
      return (
        <FaCamera
          style={{ marginLeft: "auto", fontSize: 22, color: "#A9A9A9" }}
        />
      );
    case "Food":
      return (
        <FaHamburger
          style={{ marginLeft: "auto", fontSize: 22, color: "#A9A9A9" }}
        />
      );
    case "Beverage":
      return (
        <FaCoffee
          style={{ marginLeft: "auto", fontSize: 22, color: "#A9A9A9" }}
        />
      );
    case "Alcohol":
      return (
        <FaGlassMartini
          style={{ marginLeft: "auto", fontSize: 22, color: "#A9A9A9" }}
        />
      );
    case "Transportation":
      return (
        <FaBus style={{ marginLeft: "auto", fontSize: 22, color: "#A9A9A9" }} />
      );
    case "Other":
      return (
        <BiDotsHorizontalRounded
          style={{ marginLeft: "auto", fontSize: 22, color: "#A9A9A9" }}
        />
      );

    case "Location":
      return <HiLocationMarker style={{ height: 20, width: 20 }} />;
    case "MdLocalDining":
      return <MdLocalDining style={{ height: 20, width: 20 }} />;
    case "MdDirectionsWalk":
      return <MdDirectionsWalk style={{ height: 20, width: 20 }} />;
    case "MdGroups":
      return <MdGroups style={{ height: 20, width: 20 }} />;
    case "MdTimer":
      return <MdTimer style={{ height: 20, width: 20 }} />;

    default:
      return (
        <p style={{ marginLeft: "auto", fontSize: 22, color: "#A9A9A9" }}>@</p>
      );
  }
};

const baseUrl = window.location.origin; 
export const addUsersTourDataToUrl = (relativeUrl, data) => {
  const jsonString = JSON.stringify(data);
  const encodedString = encode(jsonString);

  const newUrl = new URL(relativeUrl, baseUrl);
  newUrl.searchParams.set("tourData", encodedString);

  return newUrl.pathname + newUrl.search + newUrl.hash;
};

export const getUsersTourDataFromUrl = (url) => {
  const parsedUrl = url.startsWith('http') 
    ? new URL(url) 
    : new URL(url, baseUrl);

  const encodedString = parsedUrl.searchParams.get("tourData");

  if (!encodedString) {
    return null;
  }

  const jsonString = decode(encodedString);

  return JSON.parse(jsonString);
};

function capitalizeFirstLetter(string) {
  if (!string) return ''; // Return empty string if input is empty or falsy
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export const validPartyTypeForExperience = (partyType, experienceType) => {
  const isShared = experienceType.toLowerCase().includes("shared");
  const isPrivate = experienceType.toLowerCase().includes("private");

  partyType = partyType.toLowerCase();

  if ((partyType === "shared" && isShared) || (partyType === "private" && isPrivate)) {
    return {
      valid: true,
      errors: [],
    };
  }
  
  return {
    valid: false,
    errors: [`Invalid Selection: ${capitalizeFirstLetter(partyType)} party cannot be booked with ${experienceType.toLowerCase()} experience`],
  };
};

export const validParticipantsCountForExperience = (participant, maxParticipants, experienceType, selectedTime) => {
  
}

export const sortExperiencesBasedOnRegion = (experiences, region) => {
  
}

export const sortByDistance = (data, type, region) => {
  // const { region } = this.state
  let exps = []
  if (!type) {
    for (const k in data) {
      data[k].forEach(exp => {
        exps.push(exp)
      })

    }
  } else {
    exps.push(...data)
  }
  // for (const k in data) {
  exps.sort((a, b) => {
    const distanceA = getDistanceFromLatLonInKm(
      region.latitude,
      region.longitude,
      a.agendaStartLocation?.lat,
      a.agendaStartLocation?.long)

    const distanceB = getDistanceFromLatLonInKm(
      region.latitude,
      region.longitude,
      b.agendaStartLocation?.lat,
      b.agendaStartLocation?.long)

    return distanceA - distanceB
  })

  return exps
}

const getDistanceFromLatLonInKm = (lat1, lon1, lat2, lon2) => {
  const R = 6371; // Radius of the earth in km
  const dLat = deg2rad(lat2 - lat1);  // this.deg2rad below
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2)
    ;
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c; // Distance in km
  return d;
}

const getLatitudeDegFromMeters = (meters) => {
  const earth = 6378.137,  //radius of the earth in kilometer
    pi = Math.PI,
    m = (1 / ((2 * pi / 360) * earth)) / 1000;  //1 meter in degree
  return meters * m;
}

const getLongitudeDegFromMeters = (latitude, meters) => {
  const earth = 6378.137,  //radius of the earth in kilometer
    pi = Math.PI,
    cos = Math.cos,
    m = (1 / ((2 * pi / 360) * earth)) / 1000;  //1 meter in degree
  return (meters * m) / cos(latitude * (pi / 180));
}

const deg2rad = (deg) => {
  return deg * (Math.PI / 180)
}

export const calculatePriceForParty = (experienceType, baseSharedPrice, basePrivatePrice, extraPersonPrice, partyType, partySize) => {
  const sharedPrice = parseFloat(baseSharedPrice) || 0 ;
  const privatePrice = parseFloat(basePrivatePrice) || 0;
  const extraPrice = parseFloat(extraPersonPrice) || 0;
  partyType = partyType.toLowerCase();
  experienceType = experienceType.toLowerCase().trim();

  // Validate inputs
  if (isNaN(sharedPrice) || isNaN(privatePrice) || isNaN(extraPrice)) {
    throw new Error("Invalid price inputs: Prices must be valid numbers or string floats.");
  }

  if (!["shared", "private"].includes(partyType)) {
    throw new Error("Invalid party type: Must be 'Shared' or 'Private'.");
  }

  if (!["shared", "private", "shared and private"].includes(experienceType)) {
    throw new Error("Invalid experience type: Must be 'Shared', 'Private', or 'Shared And Private'.");
  }

  if (!Number.isInteger(partySize) || partySize < 1) {
    return 0
  }

  let basePrice;

  // Determine if the party type is valid for the experience type
  if (experienceType === "shared and private" || experienceType === partyType) {
    basePrice = partyType === "shared" ? sharedPrice : privatePrice;
  } else {
    // If conflicting, use the opposite experience type
    basePrice = partyType === "shared" ? privatePrice : sharedPrice;
  }

  // Calculate the total price
  const extraMembers = Math.max(0, partySize - 1);
  const totalPrice = basePrice + extraMembers * extraPrice;

  return totalPrice;
}